// extracted by css-extract-rspack-plugin
export default {"cls1":"PingAnswerStyles-cls1_Zue","cls2":"PingAnswerStyles-cls2_qBg PingAnswerStyles-cls1_Zue"};